// todo this will be a global mixing with an accessible method
import Axios from "axios";
import Router from "../router.js";

export const axios = {

    data() {
        return {
            userContext: {},
            photofixrOrders: false,
            instantPrintOrders: false,
            expiry: new Date(Date.now() + 24 * 3600000).getTime()
            // expiry: new Date(Date.now() + 24 * 3600000).toString()
        }
    },
    created() {
    },
    methods: {
        removeLoginSession() {
            // window.sessionStorage.removeItem('_loginExpiry')
            // window.sessionStorage.removeItem('_token')
            // window.sessionStorage.removeItem('_customerName')
            // window.sessionStorage.removeItem('_customer')
            // window.sessionStorage.removeItem('_role')
            // window.sessionStorage.removeItem('_customerType')

            window.sessionStorage.clear()
        },

        returnCookie(key) {

            return window.sessionStorage.getItem(key)
            // return this.userContext[key]
        },
        returnContentHeader() {
            return {
                headers: {
                    "content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Accept-Encoding": "gzip"
                }
            }
        },
        returnContentHeaderStream() {
            return {
                headers: {
                    "content-type": "application/octet-stream",
                    "Access-Control-Allow-Origin": "*",
                    "Accept-Encoding": "gzip"
                }
            }
        },
        returnAcceptHeader() {
            return {
                headers: {
                    "accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Accept-Encoding": "gzip"
                }
            }
        },
        returnHeaderNoToken() {
            return {
                headers: {
                    "content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Accept-Encoding": "gzip"
                }
            }
        },
        returnHeaderUsingToken() {
            return {
                headers: {
                    "content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Authorization": "Bearer " + window.sessionStorage.getItem('_auth_token'),
                    // "Accept-Encoding": "gzip"
                }
            }

        },
        returnFormHeaderUsingToken() {
            return {
                headers: {
                    "content-type": "multipart/form-data",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Authorization": "Bearer " + window.sessionStorage.getItem('_auth_token'),
                    "Accept-Encoding": "gzip"
                }
            }

        },
        returnHeaderUsingParameter(singleSignOn) {
            return {
                headers: {
                    "content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Authorization": "Bearer " + singleSignOn,
                    "Accept-Encoding": "gzip"
                }
            }
        },
        async checkDatabookToken() {

            console.log('check token');
            let token = window.sessionStorage.getItem('_databook_auth_token');
            let return_value;
            console.log('token: ' + token);

            //check if the Databook token is still valid
            var test_token_call = `${process.env.VUE_APP_TKGATEWAY}` + '/search?token=' + token + '&freetext=%22BT93%204FB%22&paf=false&named=true&rows=1';
            console.log('endpoint=' + test_token_call);

            await Axios.get(test_token_call, this.returnHeaderUsingToken())
                .then(response => {
                    console.log('test search success');

                    return_value = {'result': 'success'};
                })
                .catch(async error => {
                    if (error.response) {
                        console.log('test search failure');

                        //re-obtain token from Databook
                        // TEMPORARY!
                        var acctNo = "RAV02",
                            userId = "136281";


                        let auth_databook_endpoint = this.databookUrl + '/auth';

                        var authCreds = {"client": acctNo, "user": userId}

                        await Axios.post(auth_databook_endpoint, authCreds, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log('auth success');
                                console.log(response.data);

                                window.sessionStorage.setItem('_databook_auth_token', response.data.token);

                                return_value = {'result': 'success'};
                            })
                            .catch(error => {
                                if (error.response) {
                                    console.log('auth failure: ' + error.response);

                                    return_value = {'result': 'error'};
                                }
                            })
                    }
                })

            console.log('return_value: ' + return_value);
            return return_value;
        },
        getUserPreferences(customerRef) {
            //let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/CatalogueBookmarks/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=IMA&customerRef=` + customerRef
            let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/CatalogueBookmarks/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&customerRef=` + customerRef
            console.log(skuFinder)

            Axios.get(skuFinder, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response)

                    const savedPrefs = response.data.result

                    let preferences = []

                    for (let i = 0; i < savedPrefs.length; i++) {

                        let current = savedPrefs[i];

                        if (current.priceCode !== undefined) {
                            //let getPrintDetails = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=IM&priceCode=` + current.priceCode + '&quantity=' + current.quantity
                            let getPrintDetails = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&priceCode=` + current.priceCode + '&quantity=' + current.quantity
                            console.log(getPrintDetails)
                            Axios.get(getPrintDetails, this.returnHeaderUsingToken())
                                .then(rifat => {

                                    let pref = rifat.data.result

                                    console.log('print products from GetPrintProductDetails ', pref.printJobSpec.fCode, pref)
                                    let currentPref = {
                                        fCode: pref.printJobSpec.fCode,
                                        lamination: pref.printJobSpec.lamination,
                                        pageCount: pref.printJobSpec.pageCount,
                                        pageHeight: pref.printJobSpec.pageHeight,
                                        pageOrientation: pref.printJobSpec.pageOrientation,
                                        pageWidth: pref.printJobSpec.pageWidth,
                                        quantity: pref.printJobSpec.quantity,
                                        stockType: pref.printJobSpec.stockType,
                                        stockWeight: pref.printJobSpec.stockWeight,
                                        productRef: pref.pricingResult.productRef
                                    }

                                    console.log('adding to preferences')
                                    preferences.push(currentPref)
                                    console.log('setting preferences')
                                    sessionStorage.setItem('_myPreferences', JSON.stringify(preferences))

                                });
                        }
                    }

                    console.log('PREFERENCES')
                    console.log(preferences)

                });
        },
        clearUserSession() {
            this.removeLoginSession()
            window.location = "/";
        }
    }
}